import { MealView } from './views/meals/MealView'
export default MealView
